import { Ambulancia, BusinessAccount, PasswordOutlined, PersonFilledOutlined } from '@icon';
import { PageHeaderWrapper, Tabs } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { Redirect, Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import PersonalProfile from './personal-profile';
import ProfilePasswordChange from './profile-password-change';
import ProfileProviders from './profile-providers';
import SpecializationProfile from './specialization-profile';

const MyProfile: React.FC = () => {
  const { formatMessage } = useIntl();
  const match = useRouteMatch();
  const { path } = match;

  const history = useHistory();
  const location = useLocation();

  const tabs = React.useMemo(
    () => [
      {
        label: 'Základné údaje',
        key: `${path}/personal`,
        Icon: PersonFilledOutlined,
      },
      {
        label: 'Bezpečnosť',
        key: `${path}/security`,
        Icon: PasswordOutlined,
      },
      {
        label: 'Moje špecializácie',
        key: `${path}/specialization`,
        Icon: Ambulancia,
      },
      {
        label: 'Moji poskytovatelia',
        key: `${path}/providers`,
        Icon: BusinessAccount,
      },
    ],
    [path, formatMessage],
  );

  return (
    <PageHeaderWrapper
      showDivider
      title={'Môj profil'}
      footer={
        <Tabs
          items={tabs}
          onChange={(key) => {
            history.push(key);
          }}
          activeKey={location.pathname}
        />
      }
    >
      <Switch>
        <Route exact path={`${path}/personal`} component={PersonalProfile} />
        <Route exact path={`${path}/specialization`} component={SpecializationProfile} />
        <Route exact path={`${path}/security`} component={ProfilePasswordChange} />
        <Route exact path={`${path}/providers`} component={ProfileProviders} />
        <Redirect to={`${path}/personal`} />
      </Switch>
    </PageHeaderWrapper>
  );
};

export default MyProfile;
